import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useUserSessionAPI } from '../app/selectors';
import { ConfirmDialog } from '../common';
import { useDeleteUserAPI, useIsSuperAdmin } from './selectors';
export var DeleteUserDialog = function (_a) {
  var open = _a.open,
    user = _a.user,
    onClose = _a.onClose,
    onUserSaved = _a.onUserSaved;
  var t = useTranslation(['manageUser', 'translation']).t;
  var isSuperAdmin = useIsSuperAdmin();
  var _b = useUserSessionAPI(),
    fetchUserSession = _b[1];
  var _c = useDeleteUserAPI(user === null || user === void 0 ? void 0 : user.id),
    deleteUserData = _c[0],
    deleteUser = _c[1],
    clearDeleteUserData = _c[2];
  useEffect(function () {
    if (open && deleteUserData.data) {
      onClose();
      onUserSaved === null || onUserSaved === void 0 ? void 0 : onUserSaved({
        created: false
      });
      !isSuperAdmin && fetchUserSession();
      return clearDeleteUserData;
    }
  }, [deleteUserData.data, onClose, onUserSaved, clearDeleteUserData, open, fetchUserSession, isSuperAdmin]);
  var handleDeleteUser = function () {
    deleteUser();
  };
  return _jsx(ConfirmDialog, {
    open: open,
    onClose: onClose,
    title: t('deleteUserTitle', {
      username: user === null || user === void 0 ? void 0 : user.name
    }),
    message: t('translation:confirmation.yesDelete'),
    onConfirm: handleDeleteUser,
    loading: !!deleteUserData.requesting,
    errors: [deleteUserData.error]
  });
};